import { useAtomValue, useSetAtom } from "jotai/index";
import { useCallback } from "react";
import { canv } from "@/canv/global";
import { frameWidget } from "@/elements/frame";
import { widgetMenuOptionsAtom, widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import { applyValue, setNewOptions } from "@/interface/WidgetMenu/lib";
import type { ActiveSubMenuState, SetActiveSubMenu } from "../../types";
import { SubMenu } from "../SubMenu/SubMenu";
import { FrameAspectRatioContent } from "./FrameAspectRatioContentContent";

interface AlignMenuProps {
    activeSubMenu: ActiveSubMenuState;
    setActiveSubMenu: SetActiveSubMenu;
}

export function FrameAspectRationMenu({ activeSubMenu, setActiveSubMenu }: AlignMenuProps) {
    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);
    const options = useAtomValue(widgetMenuOptionsByNameAtom("frameAspectRatio"));

    const handleButtonClick = useCallback(
        (ratio: string) => {
            const setNewTextAlignOptions = setNewOptions({
                name: "frameAspectRatio",
                setWidgetMenuOptions,
            });
            if (
                canv.canvasController.selected.length &&
                canv.canvasController.selected[0].children[0] instanceof frameWidget
            ) {
                function handleClose() {
                    setActiveSubMenu(null);
                }

                applyValue({
                    options: options,
                    value: ratio,
                    setNewOptions: setNewTextAlignOptions,
                    handleClose,
                });
            }
        },
        [setActiveSubMenu, options, setWidgetMenuOptions],
    );

    return (
        <SubMenu activeSubMenu={activeSubMenu}>
            <FrameAspectRatioContent onClick={handleButtonClick} />
        </SubMenu>
    );
}
